<template lang="pug">
.profile-performance
  HScroll()
    GoalsPanel(:user='user')
    LeaderBoardPanel
    SellRecordPanel

</template>

<script>
import GoalsPanel from '@/components/profile-performance/panels/GoalsPanel.vue';
import LeaderBoardPanel from '@/components/profile-performance/panels/LeaderBoardPanel.vue';
import SellRecordPanel from '@/components/profile-performance/panels/SellRecordPanel.vue';

export default {
  data: () => ({
    isLoading: false,
    user: {},
  }),
  watch: {
    // ..
  },
  async created() {
    this.loadUserInfo();
  },
  methods: {
    async loadUserInfo() {
      this.isLoading = true;

      const res = await this.$api.user.myProfile();
      if (res.status === 200) {
        this.user = res.data;
      }

      this.isLoading = false;
    },
  },
  components: {
    GoalsPanel,
    LeaderBoardPanel,
    SellRecordPanel,
  },
};
</script>

<style lang="scss">
.profile-performance {
  > .h-scroll {
    height: 100%;
  }
}
</style>
